export enum Personas {
  ORTHO_SURGEON = 'orthopaedic surgeon',
  OFFICE_ADMIN = 'office administrator',
  FRONT_OFFICE = 'office staff',
  PATIENT = 'patient',
  PA_RN_NP = 'PA/RN/NP',
  GENERAL_PRACITIONER = 'general practitioner',
};
